import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
    StyledDropdownItem,
    StyledDropdownSubItem,
    StyledLink
} from './DropdownItem.styled'

const DropdownItem = (props) => {
    const {
        columnId,
        subItems,
        itemId,
        setSelectedColumn,
        selectedColumn,
        selectedItem,
        setSelectedItem,
        slug,
        title,
    } = props
    const isBrowser = typeof window !== 'undefined'

    const [alreadySelected, setAlreadySelected] = useState(false)

    useEffect(() => {
        if (isBrowser) {
            const currentLocation = window.location.pathname
            if (currentLocation === `/${slug}`) setAlreadySelected(true)
        }
    }, [])

    const handleChangeSelectedSubItems = () => {
        setSelectedItem(itemId === selectedItem ? null : itemId)
        setSelectedColumn(
            itemId === selectedItem && columnId === selectedColumn ? null : columnId
        )
    }

    const isSelected = itemId === selectedItem && columnId === selectedColumn

    return (
        <StyledDropdownItem
            $hasSubItems={subItems}
            $isSelected={isSelected || alreadySelected}
        >
            <StyledLink to={`/${slug}`}>{title}</StyledLink>
            {subItems && (
                <StyledDropdownSubItem className="subitems">
                    {subItems?.map((subItem, index) => {
                        return (<DropdownItem
                            key={subItem.id}
                            slug={subItem.pageReference?.slug ?? slug}
                            title={subItem.name}
                            itemId={index}
                        />)
                    })}
                </StyledDropdownSubItem>
            )}
        </StyledDropdownItem>
    )
}

DropdownItem.propTypes = {
    columnId: PropTypes.number,
    hasSubItems: PropTypes.array,
    itemId: PropTypes.number,
    setSelectedColumn: PropTypes.func,
    selectedColumn: PropTypes.number,
    setSelectedItem: PropTypes.func,
    selectedItem: PropTypes.number,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
}

export default DropdownItem
